/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2EmployeeWorkHours/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2EmployeeWorkHours({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2EmployeeWorkHours",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2
  
}) {
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let fill2OrdtColorsBlack = fill2 ?? dtColorsBlack
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2EmployeeWorkHours.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z25yKfE': alignSelf,'--mt-2-Z25yKfE': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z25yKfE': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z25yKfE': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z25yKfE': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z25yKfE': opacity,'--w-10-Z25yKfE': typeof width === 'number' ? `${width}px` : width,'--h-11-Z25yKfE': typeof height === 'number' ? `${height}px` : height,'--f-12-Z25yKfE': fill,'--a-7-Z25yKfE': isAnimated ? animation : "none",'--sd-8-Z25yKfE': isAnimated ? strokeDashoffset : 0,'--sd-9-Z25yKfE': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2EmployeeWorkHours.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.143 2C2.959 2 2 2.96 2 4.143v15.714C2 21.041 2.96 22 4.143 22h15.714C21.041 22 22 21.04 22 19.857V4.143C22 2.959 21.04 2 19.857 2H4.143zM12 6.821a.893.893 0 100 1.786h5.714a.893.893 0 000-1.786H12zm-2.857 4.286a.893.893 0 000 1.786h5.714a.893.893 0 100-1.786H9.143zm-3.75 5.179c0-.493.4-.893.893-.893H12a.893.893 0 110 1.786H6.286a.893.893 0 01-.893-.893z"
 style={{'--f-12-Z25yKfE': fill2OrdtColorsBlack}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}